import { render, staticRenderFns } from "./bottom-navbar.vue?vue&type=template&id=5373cc09&scoped=true&"
import script from "./bottom-navbar.vue?vue&type=script&lang=js&"
export * from "./bottom-navbar.vue?vue&type=script&lang=js&"
import style0 from "./bottom-navbar.vue?vue&type=style&index=0&id=5373cc09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5373cc09",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5373cc09')) {
      api.createRecord('5373cc09', component.options)
    } else {
      api.reload('5373cc09', component.options)
    }
    module.hot.accept("./bottom-navbar.vue?vue&type=template&id=5373cc09&scoped=true&", function () {
      api.rerender('5373cc09', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/navbar/bottom-navbar.vue"
export default component.exports